<template>
    <div id="container" class="container">
        <myheader2></myheader2>
        <div class="main-page-outer min-width">
            <div class="mx1360 main-count2 flex-r">
                <div class="left-cont">
                    <centerNavBar name="账户绑定"></centerNavBar>
                </div>
                <div class="right-cont">
                    <div class="bind-box">
						<div class="title">
							账户绑定
						</div>
						<div class="bind-list">
							<ul>
								<li class="align-c between">
									<div class="left align-c">
										<img  src="@/static/z-icon-wx.png" class="icon"/>
										<div class="t1">绑定微信账号：</div>
										<div class="t2 st1">未绑定</div>
									</div>
									<div class="btn cur curadm" @click="tobindpage">绑定</div>
								</li>
								<li class="align-c between">
									<div class="left align-c">
										<img  src="@/static/z-icon-zfb.png" class="icon"/>
										<div class="t1">绑定微信账号：</div>
										<div class="t2 st2">已绑定</div>
									</div>
									<div class="btn cur curadm">解绑</div>
								</li>
							</ul>
						</div>
					</div>
                </div>

            </div>
        </div>
        <myfooter2></myfooter2>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js"
export default {
    name: "userbind",
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
    },
    methods: {
		tobindpage(){
			util.tourl("/bindpage/wechart")
		},
    },
};
</script>

<style lang="scss">
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用
@import './userbind.scss';
</style>